import React from 'react';
import { Button, ButtonVariant, Modal } from '@usealloy/component-library';
import PropTypes from 'prop-types';
import { Colors, RiskLevels } from '~/constants';

const InfoModalPropTypes = {
  color: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  high: PropTypes.string.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  low: PropTypes.string.isRequired,
  model: PropTypes.string.isRequired,
  riskLevel: PropTypes.string.isRequired,
  score: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onToggleModal: PropTypes.func.isRequired,
};

function InfoModal({
  color,
  description,
  high,
  isModalOpen,
  low,
  model,
  onToggleModal,
  riskLevel,
  score,
  title,
}) {
  const isHighGreaterThanLow = parseFloat(high) > parseFloat(low);

  const scoreRanges = [
    {
      range: isHighGreaterThanLow ? `<${low}` : `>${low}`,
      title: `${RiskLevels.LOW} Risk`,
      color: Colors.GREEN,
    },
    {
      range: isHighGreaterThanLow ? `${low}-${high}` : `${high}-${low}`,
      title: 'Moderate Risk',
      color: Colors.ORANGE,
    },
    {
      range: isHighGreaterThanLow ? `>${high}` : `<${high}`,
      title: `${RiskLevels.HIGH} Risk`,
      color: Colors.RED,
    },
  ];

  const scoreRangesToMap = isHighGreaterThanLow
    ? scoreRanges
    : scoreRanges.reverse();

  const footNote = `* Based on ${title}'s Best Practices`;

  return (
    <Modal
      data-testid="info-modal"
      isOpen={isModalOpen}
      hasCloseIcon={false}
      primaryAction={(
        <Button
          variant={ButtonVariant.secondary}
          onClick={onToggleModal}
        >
          Close
        </Button>
      )}
    >
      <div className="diligence-info-modal-wrapper">
        <div>
          <div>
            <div className="score-chart-container">
              <div
                className="doughnut flex flex-col"
                style={{ borderColor: color }}
              >
                <p className="score header-8">{score}</p>
                <p className="smaller-text bold">{`${riskLevel} Fraud Risk*`}</p>
              </div>
            </div>
            <div className="legend-wrapper">
              {scoreRangesToMap.map(scoreRange => (
                <div key={scoreRange.title}>
                  <div
                    className="rectangle"
                    style={{ backgroundColor: scoreRange.color }}
                  />
                  <p className="flex smaller-text bold line-height-normal">
                    {scoreRange.range}
                  </p>
                  <p className="flex smaller-text line-height-normal">
                    {scoreRange.title}
                  </p>
                </div>
              ))}
            </div>
            <p className="flex smallest-text bold">{footNote}</p>
          </div>
          <div className="score-description-container">
            <h2 className="line-height-normal letter-spacing-normal">
              {title}
            </h2>
            <p className="subtitle">{model}</p>
            <hr />
            <p className="description smaller-text header-top-16">
              {description}
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
}
InfoModal.propTypes = InfoModalPropTypes;

export default InfoModal;
